import React, { Component } from "react";
import { Alert, Button, Spin } from "antd";
import ReCAPTCHA from "react-google-recaptcha";

import { PostData } from "../../api/service";
import { RECAPTCHA_SITE_KEY, isValidEmail } from "../../Helper/GlobalConstants";

/**
 * Step 1 — find the student, then their admission fee receipts.
 *
 * Three outcomes, three distinct messages: no unique student, a student with no
 * admission receipt, or receipts found. There is no "continue anyway" branch —
 * without a receipt on record there is nothing to reprint.
 */
export default class AdmissionPrintIdentifyStep extends Component {
  state = {
    roll_no: "",
    email: "",
    recaptcha_token: "",
    isLoading: false,
    message: "",
    messageType: "error"
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = () => {
    if (this.state.roll_no.trim() === "") {
      this.setState({ message: "Please enter your roll number", messageType: "error" });
      return;
    }

    if (!isValidEmail(this.state.email)) {
      this.setState({ message: "Please enter a valid email address", messageType: "error" });
      return;
    }

    if (this.state.recaptcha_token === "") {
      this.setState({ message: "Please complete the captcha", messageType: "error" });
      return;
    }

    this.setState({ isLoading: true, message: "" });

    PostData("/lookup-admission-receipts", {
      roll_no: this.state.roll_no,
      email: this.state.email,
      recaptcha_token: this.state.recaptcha_token
    })
      .then((resp) => {
        this.setState({ isLoading: false });

        if (resp && resp.status === true) {
          this.props.onFound(resp, this.state.roll_no, this.state.email);
        } else {
          this.setState({
            message:
              resp && resp.status_text
                ? resp.status_text
                : "We could not find your record.",
            messageType: "warning"
          });
        }
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          message: "Something went wrong. Please try again.",
          messageType: "error"
        });
      });
  };

  render() {
    return (
      <div>
        <Alert
          type="info"
          showIcon
          message="Lost your admission fee receipt?"
          description="Pay the reprint fee here and collect a reprinted copy from the college office. If you have not been given your receipt yet, contact the office first — your first copy is free."
        />
        <br />

        <p>
          Enter your roll number and the email address the college has on record.
        </p>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Roll Number *</label>
              <input
                type="text"
                className="form-control"
                name="roll_no"
                maxLength={50}
                value={this.state.roll_no}
                onChange={this.onChange}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                className="form-control"
                name="email"
                maxLength={50}
                value={this.state.email}
                onChange={this.onChange}
              />
            </div>
          </div>
        </div>

        <ReCAPTCHA
          sitekey={RECAPTCHA_SITE_KEY}
          onChange={(token) => this.setState({ recaptcha_token: token || "" })}
        />
        <br />

        {this.state.message !== "" && (
          <div>
            <Alert
              type={this.state.messageType}
              message={this.state.message}
              showIcon
            />
            <br />
          </div>
        )}

        {this.state.isLoading ? (
          <Spin />
        ) : (
          <Button type="primary" onClick={this.onSubmit}>
            Find my receipts
          </Button>
        )}
      </div>
    );
  }
}
